// extracted by mini-css-extract-plugin
export default {"modalFooter":"Modal_Footer_modalFooter__Nv2wa"};